/**
 * The `pending:<email>` person-key contract, UI side, plus the UPN name
 * heuristic. NO IMPORTS, deliberately: the directory hook itself pulls in the
 * Dataverse client and its env config, and these helpers need to be testable
 * without either.
 *
 * MIRRORED in packages/bff/src/academy/pendingPerson.ts, which cannot import
 * this module. Both sides are pinned by a test. If the format changes on one
 * side only, a pre-provisioned person's assignments never get re-keyed to
 * their real oid on first sign-in, and their training silently never appears.
 */

export const PENDING_PERSON_PREFIX = 'pending:';

/** The synthetic id for a pre-provisioned person we know only by email.
 *  Lowercased so the key the BFF reconciles against cannot drift on casing. */
export function pendingPersonKey(email: string): string {
  return `${PENDING_PERSON_PREFIX}${email.trim().toLowerCase()}`;
}

/**
 * Best-effort display name from a UPN. Only trustworthy for dotted UPNs:
 * this tenant's are first-initial + surname, so 'laspenwall@...' yields
 * 'Laspenwall'. That is why a real `fullname` from systemusers always wins,
 * and why a pre-provisioned person is labelled with their email instead.
 */
export function prettyNameFromUpn(upn: string): string {
  const local = upn.split('@')[0] ?? upn;
  return local
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}
